export const SET_DISABLED_SPEED_TIERS = 'SET_DISABLED_SPEED_TIERS';

export const setDisabledSpeedTiers = disabledSpeedTiers => ({
  type: SET_DISABLED_SPEED_TIERS,
  value: {disabledSpeedTiers},
});
